module.exports = __webpack_public_path__ + "static/media/achievement-elastic-adventurer.0d115c65.svg";